module.exports = __webpack_public_path__ + "img/toolDetailsBj.a5bd70dd.png";